import { createAuthClient } from 'better-auth/vue';

const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export const authClient = createAuthClient({
  baseURL: apiUrl,
  basePath: '/auth',
  fetchOptions: {
    credentials: 'include' as const,
  },
});

export const { signIn, signUp, signOut, useSession } = authClient;
